import React, {ChangeEvent} from "react";
import {AppApi} from "../../../../utils/AppApi";
import {useAlert} from "../../../../utils/components/providers/AlertProvider";
import {Utils} from "../../../../utils/Utils";
import {Administrator} from "./Administrators";

export default function AddAdmin(params: { show: boolean, admin: Administrator, close: (admin?: Administrator) => void }) {
    const {showMessage} = useAlert()
    const [admin, setAdmin] = React.useState<Administrator & { password: string, confirm: string, reset: boolean }>(
        {...params.admin, reset: false, password: '', confirm: ''})
    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setAdmin({...admin, [event.target.name]: event.target.value})
    }

    const saveAdmin = () => {
        Utils.toggleSpinner('show')
        AppApi.saveAdministrator({
                admin_id     : admin.admin_id,
                email_address: admin.email_address.trim(),
                first_name   : admin.first_name,
                last_name    : admin.last_name,
                password     : admin.password,
                username     : admin.username
            })
            .then(res => {
                Utils.toggleSpinner('hide')
                if (res.data.success) {
                    params.close({...admin, admin_id: res.data.admin_id})
                } else {
                    showMessage({message: res.data.message, type: 'error'})
                }
            })
            .catch(() => {
                Utils.toggleSpinner('hide')
                showMessage({message: 'Error saving administrator, please retry', type: 'error'})
            })
    }

    React.useEffect(() => {
        setAdmin({...params.admin, reset: false, password: '', confirm: ''})
    }, [params.admin])

    return (
        <div className={`modal_container ${params.show ? 'show' : ''}`.trim()}>
            <div className="modal_body">
                <h6 className="mb-4">{params.admin.admin_id === 0 ? 'Add Administrator' : 'Edit Administrator'}</h6>

                <form method="post">
                    <div className="mb-3">
                        <label htmlFor="first_name" className="form-label">First Name</label>
                        <input type="text" className="form-control" id="first_name" name="first_name"
                               value={admin.first_name} onChange={handleChange} required/>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="last_name" className="form-label">Last Name</label>
                        <input type="text" className="form-control" id="last_name" name="last_name"
                               value={admin.last_name} onChange={handleChange} required/>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="username" className="form-label">Username</label>
                        <input type="text" className="form-control" id="username" name="username"
                               value={admin.username} onChange={handleChange} required/>
                    </div>

                    <div className="mb-3">
                        <label htmlFor="email_address" className="form-label">Email Address</label>
                        <input type="email" className="form-control" id="email_address" name="email_address"
                               value={admin.email_address} onChange={handleChange} required/>
                    </div>

                    {
                        admin.admin_id !== 0 &&
                        <div className="mb-0">
                            <label htmlFor="reset" className="form-label">Reset account password</label>
                            <input type="checkbox" className="form-check" id="reset" name="reset"
                                   checked={admin.reset} required
                                   onChange={(event) => {
                                       setAdmin({...admin, reset: event.target.checked})
                                   }}/>
                        </div>
                    }

                    {
                        (admin.admin_id === 0 || admin.reset) &&
                        <>
                            <div className="mb-3">
                                <label htmlFor="password" className="form-label">Password</label>
                                <input type="password" className="form-control" id="password" name="password"
                                       required value={admin.password} onChange={handleChange}/>
                            </div>
                            <div className="mb-3">
                                <label htmlFor="confirm" className="form-label">Confirm Password</label>
                                <input type="password" className="form-control" id="confirm" name="confirm"
                                       required value={admin.confirm} onChange={handleChange}/>
                            </div>
                        </>
                    }
                </form>

                <div className={'form_buttons'}>
                    <div className={'row m-0'}>
                        <div className={'col-6 ps-0 pe-1'}>
                            <button type="button" className="btn btn-secondary" onClick={() => params.close()}>Close Window</button>
                        </div>
                        <div className={'col-6 ps-1 pe-0'}>
                            <button type="button" className="btn btn-primary" onClick={saveAdmin}>Add Administrator</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}